/*@ngInject*/
const FormRuleBuilderController = function ($element,uiFormTemplateModel) {
    $element.addClass('formRuleBuilder');

    this.uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();

};

angular.module('ums.configuration')
    .controller('formRuleBuilderController', FormRuleBuilderController);
